import { render, staticRenderFns } from "./MainHero.vue?vue&type=template&id=4c4a6cac&scoped=true&"
var script = {}
import style0 from "./MainHero.vue?vue&type=style&index=0&id=4c4a6cac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4a6cac",
  null
  
)

export default component.exports